// Google Maps configuration
export const GOOGLE_MAPS_CONFIG = {
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  placeId: import.meta.env.VITE_GOOGLE_PLACE_ID,
  libraries: ["places"],
  region: "IN",
  language: "en",
  version: "weekly",
} as const;
